<div class="password-strength-indicator" *ngIf="password || showGuidance">
  <!-- Guidance message (always shown when showGuidance is true) -->
  <div class="guidance-message" *ngIf="showGuidance && !password">
    <mat-icon class="info-icon">info</mat-icon>
    <span class="guidance-text">{{ guidanceMessage }}</span>
  </div>

  <!-- Strength indicator (shown when password is entered) -->
  <div class="strength-container" *ngIf="password && strengthResult">
    <!-- Strength label and progress bar -->
    <div class="strength-header">
      <span class="strength-label">Password strength: </span>
      <span class="strength-value" [ngClass]="getStrengthClass()">
        {{ getStrengthLabel() }}
      </span>
    </div>

    <!-- Progress bar -->
    <div class="strength-progress">
      <div class="progress-bar-background">
        <div
          class="progress-bar-fill"
          [ngClass]="getStrengthClass()"
          [style.width]="getProgressWidth()"
        ></div>
      </div>
    </div>

    <!-- Feedback messages -->
    <div class="feedback-messages" *ngIf="strengthResult.feedback.length > 0">
      <div
        class="feedback-item"
        *ngFor="let feedback of strengthResult.feedback"
        [ngClass]="{
          'feedback-error': strengthResult.strength === PasswordStrength.WEAK,
          'feedback-warning':
            strengthResult.strength === PasswordStrength.MODERATE,
          'feedback-success':
            strengthResult.strength === PasswordStrength.STRONG
        }"
      >
        <mat-icon class="feedback-icon">
          {{
            strengthResult.strength === PasswordStrength.STRONG
              ? 'check_circle'
              : 'info'
          }}
        </mat-icon>
        <span>{{ feedback }}</span>
      </div>
    </div>

    <!-- Show guidance below feedback if password is weak -->
    <div
      class="guidance-message mt-2"
      *ngIf="strengthResult.strength === PasswordStrength.WEAK && showGuidance"
    >
      <mat-icon class="info-icon">info</mat-icon>
      <span class="guidance-text">{{ guidanceMessage }}</span>
    </div>
  </div>
</div>
